import { Component, Vue, Prop as prop, Prop} from 'nuxt-property-decorator';

@Component
export default class ConfiguratorImageRow extends Vue {

    @Prop() option;
    @Prop() current;
    @Prop() matchedOffers;
}
